import { createContext } from "react";
export var AppContext = /*#__PURE__*/createContext({});